import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background">
      <div className="container-main py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center" data-testid="footer-logo">
              <img src="/images/muse-logo.png" alt="Muse Social Creative Agency" className="h-48 w-auto brightness-0 invert" />
            </Link>
            <p className="mt-4 text-background/60 text-sm leading-relaxed">
              We build brands that feel impossible to ignore.
            </p>
          </div>

          <div>
            <h4 className="font-sans font-semibold text-background mb-4 text-sm tracking-wide uppercase">Explore</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-services">Services</Link></li>
              <li><Link to="/method" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-method">The Muse Method</Link></li>
              <li><Link to="/portfolio" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-portfolio">Portfolio</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-sans font-semibold text-background mb-4 text-sm tracking-wide uppercase">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-about">About</Link></li>
              <li><Link to="/services/vip-content-days" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-vip">VIP Content Days</Link></li>
              <li><Link to="/book-a-call" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-sans font-semibold text-background mb-4 text-sm tracking-wide uppercase">Connect</h4>
            <ul className="space-y-3">
              <li><a href="mailto:hello@musesocialcreative.com" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-email">hello@musesocialcreative.com</a></li>
              <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-linkedin">LinkedIn</a></li>
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-background/60 hover:text-background transition-colors duration-200 text-sm" data-testid="footer-instagram">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-background/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-background/40 text-sm">&copy; {currentYear} Muse Social Creative. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/admin" className="text-background/20 hover:text-background/40 transition-colors duration-200 text-xs" data-testid="footer-admin">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
